import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAssignUserReq,
  getCourseReportReq,
  getCourseReportResClear,
  getTeamMatesReq,
  getTeamMatesResClear,
  setCurrentView,
} from "../../redux/assignCourse/actions";
import { setCurrentFilterView } from "../../redux/reports/actions";
import { SessionKeys } from "../../utils/AppUtils";
import StaticUtils from "../../utils/StaticUtils";
import Select from "react-select";
import { useTranslation } from "react-i18next";
const ChooseCourse = (props) => {
  const {
    selectedCourseList,
    setSelectedCourseList,
    parentId,
    parentName,
    currentReportObj,
    isMobile,
    isCompliance,
    courseOrVideoSelector,
    selectedBrokerageList,
    isAP,
  } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { courseId } = useParams();

  const courseSearchRes = useSelector(
    (state) => state.assignCourse.courseReportList
  );
  const assignedUserRes = useSelector(
    (state) => state.assignCourse.assignedUsers
  );
  const [searchInput, setSearchInput] = useState("");
  const [courseList, setCourseList] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [courseOptList, setCourseOptList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValue, setDefaultValue] = useState([]);

  // useEffect(() => {
  //   dispatch(getCourseReportResClear());
  //   searchCourse();
  // }, []);

  useEffect(() => {
    setSelectedCourseList([]);
    setCourseOptList([]);
    setIsLoading(true);
    searchCourse();
  }, [selectedBrokerageList]);

  // useEffect(() => {
  //   dispatch(getCourseReportResClear());
  //   searchCourse();
  // }, [courseOrVideoSelector]);

  useEffect(() => {
    setSelectedCount(selectedCourseList?.length);
    const newDefaultValue = _.map(selectedCourseList, (course) => {
      if (isAP) {
        return {
          value: course.id,
          label: course.name,
        };
      } else if (course.source === "broker") {
        return {
          value: course.course_id,
          label: course.course_name,
        };
      } else {
        return {
          value: course.course_code,
          label: course.course_name,
        };
      }
    });

    setDefaultValue(newDefaultValue);
  }, [selectedCourseList]);

  useEffect(() => {
    if (searchInput !== undefined && searchInput.length > 2) searchCourse();
    else setErrorMsg("");
  }, [searchInput]);

  const searchCourse = () => {
    if(isAP){
      dispatch(
        getCourseReportReq({
          module: "chooseActionPath",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            brokerage: selectedBrokerageList,
          },
        })
      );
    } else if (isCompliance === 1) {
      dispatch(
        getCourseReportReq({
          module: "chooseCourse",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            search: searchInput,
            compliance: 1,
            brokerage: selectedBrokerageList,
          },
        })
      );
    } else {
      dispatch(
        getCourseReportReq({
          module: "chooseCourse",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            search: searchInput,
            compliance: 0,
            is_videos: courseOrVideoSelector,
            brokerage: selectedBrokerageList,
          },
        })
      );
    }
  };

  useEffect(() => {
    // console.log("courseSearchRes: ", courseSearchRes);
    if (!_.isEmpty(courseSearchRes)) {
      if (courseSearchRes?.status === "success") {
        const courseArr = courseSearchRes?.payload?.payload;
        setCourseList(courseArr);
        setCourseOptList(
          _.map(courseArr, (course) => {
            if(isAP){
              return {
                value: course.id,
                label: course.name,
              };
            } else if (course.source === "broker") {
              return {
                value: course.course_id,
                label: course.course_name,
              };
            } else {
              return {
                value: course.course_code,
                label: course.course_name,
              };
            }
          })
        );
        if (
          !_.isEmpty(searchInput) &&
          searchInput?.length > 2 &&
          courseSearchRes?.payload?.payload?.length === 0
        ) {
          setErrorMsg(t("No result found for your search."));
        } else {
          setErrorMsg("");
        }
      } else {
        setCourseOptList([]);
      }
    } else {
      setErrorMsg("");
      setCourseList([]);
    }
  }, [courseSearchRes]);

  const isContainObject = (list, obj, from) => {
    let isContain = false;

    for (const item of list) {
      if (from === 0) {
        if (item.course_id === obj.course_id) {
          isContain = true;
        }
      } else if (from === 1) {
        if (item.id === obj.id) {
          isContain = true;
        }
      }
    }
    // console.log("isContain: ", isContain);
    return isContain;
  };

  const selectItem = (index) => {
    let tempArr = _.cloneDeep(courseList);
    let selectedTempArray = _.cloneDeep(selectedCourseList);
    if (!isContainObject(selectedTempArray, tempArr[index], 0)) {
      selectedTempArray.push(tempArr[index]);
    }

    setSelectedCourseList(selectedTempArray);
    tempArr.splice(index, 1);
    setCourseList(tempArr);
  };

  const removeItem = (index) => {
    let selectedTempArray = _.cloneDeep(selectedCourseList);
    let tempArr = _.cloneDeep(courseList);

    if (!isContainObject(tempArr, selectedTempArray[index], 0)) {
      tempArr.push(selectedTempArray[index]);
    }

    setCourseList(tempArr);
    selectedTempArray.splice(index, 1);
    setSelectedCourseList(selectedTempArray);
  };

  return (
    <>
      <div className="chooseteamate">
        <h4>
          {isAP?t("Choose Action Paths"):t("Choose Assets")}
          {/* {parentName} */}
        </h4>
        <div className="input-lear position-relative d-flex">
          <label for="teamsearch" className="input__label">
            {t("Search")}
          </label>
          {/* <input
            type="text"
            id="teamsearch"
            name="teamsearch"
            className="input_searchfield_search-cart "
            placeholder="Start searching"
            onChange={(evt) => {
              setSearchInput(evt.target.value);
            }}
          /> */}
          <Select
            isMulti
            name="colors"
            className="basic-multi-select w-100 multi-label-select"
            classNamePrefix="xsel"
            options={courseOptList}
            value={defaultValue}
            onChange={(e) => {
              console.log(e);
              // setSelectedOffice(e)
              if (!_.isEmpty(e)) {
                setErrorMsg("");
                let data = [];
                for (let course of courseList) {
                  for (let sO of e) {
                    if(isAP){
                      if (sO.value === course.id) {
                        data.push(course);
                      }
                    } else if (course.source === "broker") {
                      if (sO.value === course.course_id) {
                        data.push(course);
                      }
                    } else {
                      if (sO.value === course.course_code) {
                        data.push(course);
                      }
                    }
                  }
                }
                console.log(data);
                setSelectedCourseList(data);
              } else {
                setSelectedCourseList([]);
                // setErrorMsg("Please select at lease one course.");
              }
            }}
          />
        </div>
        <p className="error-msg">{errorMsg}</p>
        {/* <div className="search-team-result">
          {courseList?.map((item, index) => {
            return (
              <div className="team-result-box">
                // {/*<div class="team-user-img">
                //   <img
                //     src={
                //       item?.profile_img !== ""
                //         ? item?.profile_img
                //         : "/images/avatar.svg"
                //     }
                //     alt="user"
                //   />
                //   </div>*
                <div className="userteamname">{item?.course_name}</div>
                <div
                  className="addteammate cursor-pointer"
                  onClick={() => {
                    selectItem(index);
                  }}
                >
                  +
                </div>
              </div>
            );
          })}
        </div>
        <div className="teamselected">
          <div className="selectresilt">
            Selected Courses<strong>({selectedCount})</strong>
          </div>
          <div className="search-team-result slectedteammates">
            {selectedCourseList?.map((item, index) => {
              return (
                <div className="team-result-box">
                  // {/*<div class="team-user-img">
                  //   <img
                  //     src={
                  //       item?.profile_img !== ""
                  //         ? item?.profile_img
                  //         : "/images/avatar.svg"
                  //     }
                  //     alt="user"
                  //   />
                  //   </div>
                  <div className="userteamname">{item?.course_name}</div>
                  <div
                    className="addteammate cursor-pointer"
                    onClick={() => {
                      //   console.log("removeItem");
                      removeItem(index);
                    }}
                  >
                    +
                  </div>
                </div>
              );
            })}
          </div>
        </div> */}

        {false && (
          <div className="buttonsteammate">
            {false && (
              <button
                type="button"
                className="btn btn-primary btn-block back-button"
                onClick={() => {
                  dispatch(setCurrentFilterView(1));
                }}
              >
                Back
              </button>
            )}

            <button
              type="button"
              className="btn btn-primary btn-block setup-button"
              onClick={() => {
                setSelectedCourseList(selectedCourseList);
                // dispatch(setCurrentFilterView(1));
              }}
            >
              Apply
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ChooseCourse;
